// @flow
import React, { useEffect, useRef, useMemo } from 'react';
import type { Element } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { NextSeo } from 'next-seo';
import { withTranslation, Link, nextRoutes } from '@i18n';
import { useBreakpoint } from '@lib/hooks/useBreakpoint';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { changeTitle } from '@redux/components/Metadata/actions';
import ProgressBar from '@components/ContributionCard/ProgressBar';
import ItemsCarousel from 'react-items-carousel';
import { Swiper, SwiperSlide } from 'swiper/react';

import SwiperCore, { Pagination, Navigation } from 'swiper';
import 'swiper/swiper-bundle.css';

import {
  StyledMiniVerticalSpacer,
  StyledPageCover,
  StyledVerticalSpacer
} from '@components/Wrappers/styles/index';

import {
  BannerDoctor,
  BannerDoctorImage,
  BannerSubHeadline,
  CostEstimateButton,
  MainHealine,
  MainSubHealine,
  StyledBannerContent,
  StyledCoverMaxWidthNoBottomMargin,
  StyledFlexCenter,
  StyledGridDesktopVisible,
  StyledGridMobileVisible,
  StyledImageOverButton,
  StyledSeeMore
} from '@screens/Details/Treatment/styles';
import waitForPageReady from '@lib/waitForPageReady';
import theme from '@lib/theme';
import moment from 'moment';
import SearchResultListItem from '@screens/Finder/Doctor/SearchResultList/SearchResultListItem/index';
import { requestDoctorList } from '@screens/Finder/Doctor/redux/actions';
import SearchResultFacilityListItem from '@screens/Finder/Facility/SearchResultList/SearchResultListItem/index';
import FAQQUESTIONEXPAND from '@components/FAQQuesExpand/index';
import {
  BLOG_CATEGORY,
  FINDER_DOCTOR,
  FINDER_FACILITY,
  YAPITA_HEALTH_URL,
  TREATMENT_COST_FLOW
} from '@routes';
import { calculateGridUnitSize } from '@lib/helpers';
import GridCarousel from '@components/GridCarousel/index';

import Campaign from '../components/CampaignForm/index';

import {
  requestBlogArticle,
  requestBlogArticles,
  requestBlogCategories,
  requestBlogTestimonial,
  resetBlogArticles
} from '../redux/actions';
import type { Props } from './types';

import {
  StyledCover,
  StyledArticleTitle,
  StyledImageContainer,
  StyledTextContent,
  MainSubHeadline,
  StyledCategoryTagsWrapper,
  StyledCategoryTag,
  StyledCardsMaxWidth,
  StyledTagSeperator,
  StyledCategoryScrollableWrapper,
  StyledDateAndLinkContainer,
  StyledSwiper
} from './styles';
import ArticleCard from './components/RelatedPostCard/articleCard';
import Testimonial from './components/TestimonialList/testimonialCard';
// import {StyledReviews} from '@components/PatientReviews/GoogleReviews/styles'
export const config = { amp: true };
SwiperCore.use([Navigation, Pagination]);

const BlogArticle = ({
  t,
  article,
  requestDoctorList,
  relatedArticles,
  requestBlogArticles,
  requestBlogTestimonial,
  doctorFinder,
  testimonials,
  changeTitle,
  campaign
}: Props): Element<any> => {
  const htmlContent = article?.attributes?.content || '';
  const [beforeBanner, afterBanner] = useMemo(() => htmlContent.split('<div id="insert-popup-banner"></div>'), [htmlContent]);
  const categories = article?.relationships?.blog_categories?.data;
  const filteredRelativeArticles = (relatedArticles || [])
    .filter(item => item.id !== article.id) || [];
  const filteredTestimonial = (testimonials || []).filter(item => item.id !== article.id) || [];
  const doctorLoadRef = useRef(null);
  const isMobile = useBreakpoint('mobile', 'tablet');
  const isTablet = useBreakpoint('tablet', 'desktop');
  // eslint-disable-next-line no-nested-ternary
  const onScreenCount = isMobile ? 2 : isTablet ? 3 : 4;
  const onScreenCountTestimonial = isMobile ? 1 : 3;
  const department = article?.relationships.treatment.data?.department;
  const includedFacilities = doctorFinder.facilityData || [];
  const doctors = doctorFinder.data;
  const Faqs = article.relationships.treatment_faqs.data;
  const { locale } = nextRoutes;

  useEffect(() => {
    requestDoctorList({ department, dontScroll: true, custom_per_page: 16 });
    requestBlogArticles({ categoryTypes: categories.map(item => item.id), customPerPage: 4 });
    requestBlogTestimonial({ customPerPage: 4 });
    return () => {
      resetBlogArticles();
    };
  }, [article]);

  useEffect((): void => {
    changeTitle({ IN: { en: article?.attributes?.title } });
  }, [article?.attributes?.title]);

  const metaData: {
    MetaTitle: string,
    MetaDescription: string
  } = t('Seo:BlogSeo', {
    returnObjects: true,
    name: article?.attributes?.title
  });
  const color = '#5FA6BF';
  const [doctorsSlide, setDoctorsSlide] = React.useState(0);
  const [intervalDoctorId, setDoctorIntervalId] = React.useState(null);
  const handleDoctorTimeInterval = () => {
    clearInterval(intervalDoctorId);
    const newId = setInterval(() => {
      setDoctorsSlide((x) => {
        if (x > (doctors || []).slice(0, 8).length - 1) {
          return 0;
        }
        return x + 1;
      });
    }, 4000);

    setDoctorIntervalId(newId);
  };
  const [facilitySlide, setFacilitySlide] = React.useState(0);
  const [intervalFacilityId, setFacilityIntervalId] = React.useState(null);
  const handleFacilityTimeInterval = () => {
    clearInterval(intervalFacilityId);
    const newId = setInterval(() => {
      setFacilitySlide((x) => {
        if (x > (includedFacilities).slice(0, 8).length) {
          return 0;
        }
        return x + 1;
      });
    }, 4000);

    setFacilityIntervalId(newId);
  };

  const calcHowOld = () => {
    if (moment().diff(article.attributes.published_at, 'days') < 1) {
      return 'Today';
    }
    if (moment().diff(article.attributes.published_at, 'days') < 32) {
      return `${moment().diff(article.attributes.published_at, 'days')} days ago`;
    }
    return `${moment(article.attributes.published_at).format('LL')}`;
  };
  const calcHowOldUpdated = () => {
    if (moment().diff(article.attributes.updated_at, 'days') < 1) {
      return 'Today';
    }
    if (moment().diff(article.attributes.updated_at, 'days') < 32) {
      return `${moment().diff(article.attributes.updated_at, 'days')} days ago`;
    }
    return `${moment(article.attributes.updated_at).format('LL')}`;
  };

  const showLoop = isMobile ? filteredRelativeArticles.length >= 2
    : filteredRelativeArticles.length >= 4;

  return (
    <>
      <NextSeo
        title={article?.attributes?.meta_title || metaData.MetaTitle}
        description={article?.attributes?.meta_description || metaData.MetaDescription}
        canonical={
          article?.attributes?.canonical_tag
          || `${YAPITA_HEALTH_URL}/${locale}/blog/articles/${article?.attributes?.slug}`
        }
        openGraph={{
          url: `${YAPITA_HEALTH_URL}/${locale}/blog/articles/${article?.attributes?.slug}`,
          title: article?.attributes?.meta_title || metaData.MetaTitle,
          description: article?.attributes?.meta_description || metaData.MetaDescription,
          site_name: 'Yapita Health',
          images: [
            {
              url:
                article?.attributes?.seo_image.url
                || 'https://yapita-production.s3.ap-south-1.amazonaws.com/images/yapita-health-og.jpg',
              width: 800,
              height: 600,
              alt: 'Yapita Health - Your Medical Partner',
              type: 'image/jpg'
            }
          ],
          siteName: 'Yapita Health'
        }}
        twitter={{
          handle: '@yapitahealth',
          site: '@yapitahealth',
          cardType: 'summary_large_image'
        }}
      />
      <StyledPageCover>
        <StyledCover>
          <StyledArticleTitle>{article?.attributes?.title}</StyledArticleTitle>

          {article?.attributes?.cover_image.url && (
            <StyledImageContainer>
              <LazyLoadImage
                src={article?.attributes?.cover_image.url}
                alt="Banner-Image"
                effect="blur"
              />
            </StyledImageContainer>
          )}
          <StyledDateAndLinkContainer>
            {t('PublishedDate')}
              &nbsp;
            <span>{calcHowOld()}</span>
          </StyledDateAndLinkContainer>
          <StyledDateAndLinkContainer>
            {t('UpdatedDate')}
              &nbsp;
            <span>{calcHowOldUpdated()}</span>
          </StyledDateAndLinkContainer>
          <StyledCategoryScrollableWrapper>
            <StyledCategoryTagsWrapper>
              {categories.map(item => (
                <>
                  <Link passHref href={BLOG_CATEGORY} params={{ slug: item.slug, id: item.id }}>
                    <StyledCategoryTag>{item.title}</StyledCategoryTag>
                  </Link>
                  <StyledTagSeperator />
                </>
              ))}
            </StyledCategoryTagsWrapper>
          </StyledCategoryScrollableWrapper>

          <StyledTextContent>
            {/* <div dangerouslySetInnerHTML={{ __html: article?.attributes?.content }} /> */}

            <div dangerouslySetInnerHTML={{ __html: beforeBanner }} />
          </StyledTextContent>
          {campaign && (
            <Campaign campaign={campaign} />
          )}
          <StyledTextContent>
            <div dangerouslySetInnerHTML={{ __html: afterBanner }} />
          </StyledTextContent>
        </StyledCover>
      </StyledPageCover>
      <StyledCardsMaxWidth>
        {filteredRelativeArticles.length > 0
        && (
          <>
            <StyledCover>
              <MainSubHeadline>{t('Posts')}</MainSubHeadline>
            </StyledCover>

            <StyledSwiper>
              <Swiper
                slidesPerView={isMobile ? 2 : 4}
                spaceBetween={5}
                loop={false}
                pagination={showLoop ? { clickable: true } : false}
                navigation={isMobile ? false : showLoop}
                slidesPerGroup={isMobile ? 2 : 4}
              >
                {filteredRelativeArticles.map(object => (
                  <SwiperSlide key={object.id}>
                    <ArticleCard
                      key={object.id}
                      size={{
                        mobile:
                      1
                      / calculateGridUnitSize(filteredRelativeArticles
                        .slice(0, 8).length, onScreenCount)
                      }}
                      article={object}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </StyledSwiper>
          </>
        )}
        {filteredTestimonial.length > 0 && (
          <>
            <StyledCover>
              <MainSubHeadline>{t('Testimonials')}</MainSubHeadline>
            </StyledCover>

            <GridCarousel
              length={filteredTestimonial.slice(0, 8).length}
              onScreenCount={onScreenCountTestimonial}
            >
              {filteredTestimonial.map(object => (
                <Testimonial
                  key={object.id}
                  size={{
                    mobile:
                      1
                      / calculateGridUnitSize(
                        filteredTestimonial.slice(0, 8).length,
                        onScreenCountTestimonial
                      )
                  }}
                  testimonial={object}
                />
              ))}
            </GridCarousel>
            <StyledFlexCenter>
              <StyledSeeMore />
            </StyledFlexCenter>
          </>
        )}
      </StyledCardsMaxWidth>
      {article?.relationships?.treatment?.data && (
        <StyledPageCover bgcolor={theme.gradients.BannerGradientLowerCostPage}>
          <StyledCoverMaxWidthNoBottomMargin>
            <StyledGridDesktopVisible>
              <BannerDoctor size={{ tablet: 1 / 2 }}>
                <BannerDoctorImage
                  src="../../../../static/images/svg/costpagedoctor1.png"
                  alt="img"
                />
              </BannerDoctor>
              <StyledBannerContent size={{ tablet: 1 / 2 }}>
                <StyledMiniVerticalSpacer>
                  <MainHealine center textcolor="white">
                    {t('DetailsJob:SecondBannerMainHeadline')}
                  </MainHealine>
                </StyledMiniVerticalSpacer>

                <BannerSubHeadline center textcolor="white">
                  {`${article?.relationships?.treatment?.data?.name} cost`}
                </BannerSubHeadline>
                <Link
                  href={TREATMENT_COST_FLOW}
                  params={{ path: 'name' }}
                  passHref
                >
                  <CostEstimateButton>{t('DetailsJob:SecondBannerButtonText')}</CostEstimateButton>
                </Link>
              </StyledBannerContent>
            </StyledGridDesktopVisible>

            <StyledGridMobileVisible>
              <MainHealine center textcolor="white" nomargin>
                {t('DetailsJob:SecondBannerMainHeadline')}
              </MainHealine>
              <StyledImageOverButton>
                <MainSubHealine textcolor="white">{`${article?.relationships?.treatment?.data?.name} cost`}</MainSubHealine>
                <Link
                  href={TREATMENT_COST_FLOW}
                  params={{ path: 'name' }}
                  passHref
                >
                  <CostEstimateButton>{t('DetailsJob:SecondBannerButtonText')}</CostEstimateButton>
                </Link>
              </StyledImageOverButton>
            </StyledGridMobileVisible>
          </StyledCoverMaxWidthNoBottomMargin>
        </StyledPageCover>
      )}

      <StyledCardsMaxWidth>
        <StyledCover>
          <MainSubHeadline ref={doctorLoadRef}>
            {t('TreatementListHeadline', {
              treatment: article?.relationships?.treatment?.data?.name
            })}
          </MainSubHeadline>
        </StyledCover>
        {isMobile
          ? (
            <>
              <ItemsCarousel
                requestToChangeActive={setDoctorsSlide}
                activeItemIndex={doctorsSlide}
                numberOfCards={1}
                gutter={20}
                alwaysShowChevrons
                showIndicators
              >
                {doctors.slice(0, 8).map(object => (
                  <SearchResultListItem
                    key={object.id}
                    size={{
                      mobile: 1
                    }}
                    bookConsultation="hide"
                    result={object}
                    blogs
                  />
                ))}
              </ItemsCarousel>
              <ProgressBar
                slide={doctorsSlide}
                handleTimeInterval={handleDoctorTimeInterval}
                setSlide={setDoctorsSlide}
                intervalId={intervalDoctorId}
                clickable
                color={color}
                homePage
                length={(doctors || []).slice(0, 8).length}
              />
            </>
          )
          : (
            <GridCarousel
              length={doctors.slice(0, 8).length}
              onScreenCount={onScreenCount}
              pagination
              homePage
              contributionCard
              blogs
            >
              {doctors.slice(0, 8).map(object => (
                <SearchResultListItem
                  key={object.id}
                  size={{
                    mobile: 1 / calculateGridUnitSize(doctors.slice(0, 8).length, onScreenCount)
                  }}
                  bookConsultation="hide"
                  result={object}
                  blogs
                />
              ))}
            </GridCarousel>
          )}

        <StyledFlexCenter blogs>
          <Link passHref href={FINDER_DOCTOR}>
            <StyledSeeMore>{t('DetailsJob:SeeAllDoctors')}</StyledSeeMore>
          </Link>
        </StyledFlexCenter>

        <StyledCover>
          <MainSubHeadline>
            {t('HospitalListHeadline', {
              treatment: article?.relationships?.treatment?.data?.name
            })}
          </MainSubHeadline>
        </StyledCover>

        {isMobile
          ? (
            <>
              <ItemsCarousel
                requestToChangeActive={setFacilitySlide}
                activeItemIndex={facilitySlide}
                numberOfCards={1}
                gutter={20}
                alwaysShowChevrons
                showIndicators
              >
                {includedFacilities.slice(0, 8).map(object => (
                  <SearchResultFacilityListItem
                    extractedFacilitiesFromDoctor
                    key={object.id}
                    size={{
                      mobile: 1
                    }}
                    result={object}
                    blogs
                  />
                ))}
              </ItemsCarousel>
              <ProgressBar
                slide={facilitySlide}
                handleTimeInterval={handleFacilityTimeInterval}
                setSlide={setFacilitySlide}
                intervalId={intervalFacilityId}
                clickable
                color={color}
                homePage
                length={(includedFacilities).slice(0, 8).length}
              />
            </>
          )
          : (
            <GridCarousel
              length={includedFacilities.slice(0, 8).length}
              onScreenCount={onScreenCount}
              pagination
              homePage
              contributionCard
            >
              {includedFacilities.slice(0, 8).map(object => (
                <SearchResultFacilityListItem
                  extractedFacilitiesFromDoctor
                  key={object.id}
                  size={{
                    mobile:
                      1
                      / calculateGridUnitSize(includedFacilities.slice(0, 8).length, onScreenCount)
                  }}
                  result={object}
                  blogs
                />
              ))}
            </GridCarousel>
          )}
        <StyledFlexCenter blogs>
          <Link passHref href={FINDER_FACILITY}>
            <StyledSeeMore href="/facility">{t('DetailsJob:SeeAllHospitals')}</StyledSeeMore>
          </Link>
        </StyledFlexCenter>
        <StyledVerticalSpacer />
      </StyledCardsMaxWidth>

      <StyledPageCover>
        <StyledCover>
          {Faqs.length > 0 && (
            <FAQQUESTIONEXPAND
              data={Faqs || []}
              heading={t('FaqHeadline', {
                treatment: article?.relationships?.treatment?.data?.name
              })}
            />
          )}
        </StyledCover>
      </StyledPageCover>
      <StyledVerticalSpacer />
    </>
  );
};

const mapStateToProps = ({ blogData, doctorFinder, campaign }) => ({
  article: blogData.singleArticleData,
  isRequesting: blogData.requesting,
  relatedArticles: blogData.data,
  testimonials: blogData.testimonialData,
  campaign: campaign.data?.data[0]?.attributes,
  doctorFinder
});

BlogArticle.getInitialProps = async ({ query, store }) => {
  store.dispatch(requestBlogArticle(query.slug));
  await waitForPageReady(store);
  return {
    query
  };
};

export default compose(
  connect(
    mapStateToProps,
    {
      requestBlogArticle,
      requestBlogArticles,
      requestBlogTestimonial,
      resetBlogArticles,
      requestDoctorList,
      requestBlogCategories,
      changeTitle
    }
  ),
  withTranslation('Blog')
)(BlogArticle);
